// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","position":"Card_position__dNEp-","description":"Card_description__jyadU"};